/* ══════════════════════════════════════════════════════════════════
   Der Grund einer Sperre wird ihre Art — nicht „sperre" für alles.

   Playbook P-15/P-16 (03.10.2026): Im Sperrblatt gewählt war „Wartung",
   „UVV-Prüfung" oder „Urlaub"; geschrieben wurde immer `art: "sperre"`.
   Der Balken sagte danach „Sperre", das Umplanen „BELEGT · Sperre" statt
   „Urlaub", und keine Auswertung kannte den Grund.

   Die Belegung kennt `wartung`, `urlaub`, `schulung` und `sperre`
   (`BELEGUNGSARTEN` in apps/api/src/dienste/belegung.ts). UVV-Prüfung und
   Werkstatt sind Wartung: Das Gerät steht auf dem Hof und wird geprüft
   oder gerichtet. Was die Bezeichnung genauer sagt, steht in der Notiz.
   Lesen geht den Weg zurück (`sperrgrundVon` in daten/routen.ts).
   ══════════════════════════════════════════════════════════════════ */

import type { SperrGrund } from "./typen";

/** Die Art der Belegung zu einem Sperrgrund. */
export function belegungsartFuerSperre(grund: SperrGrund | null | undefined): "wartung" | "urlaub" | "schulung" | "sperre" {
  switch (grund) {
    case "wartung":
    case "uvv":
    case "werkstatt":
      return "wartung";
    case "urlaub":
      return "urlaub";
    case "schulung":
      return "schulung";
    default:
      return "sperre";
  }
}
